import React, { useState, useEffect } from "react";
import i18n from "../../../lib/i18n/i18n";
import { connect } from "react-redux";
import { Container, Title } from "./testers.styles";
import NewTester from "./NewTester/NewTester";
import TestersData from "./TestersData/TestersData";
import { getSchoolTesters } from "../../../actions/testersActions";
import Table from "../../SivanPlusTable/SivanPlusTable";
import CreateButton from "../../UiComponents/Buttons/Default";

const currLanguage = i18n.language;
const dictionary = i18n.getDataByLanguage(currLanguage).common;

const vehicleColumns = [
  {
    Header: dictionary.table.name,
    accessor: "firstName",
    Cell: ({ row: { original } }) =>
      `${original.firstName} ${original.lastName}`,
  },
  {
    Header: dictionary.table.active,
    accessor: "isActive",
    Cell: ({ row: { original } }) =>
      original.isActive === 1
        ? dictionary.users.active
        : dictionary.users.inactive,
  },
];

const FundingBodies = ({ testers, isLoaded, getSchoolTesters }) => {
  const [isProviderModalOpen, setProviderModalOpen] = useState(false);
  const [providerData, setProviderData] = useState(false);
  const [isProviderDetailsModalOpen, setProviderDetailsModalOpen] = useState(
    false
  );

  const onRowClick = async (rowObject) => {
    setProviderDetailsModalOpen(true);
    setProviderData(rowObject.original);
  };

  useEffect(() => {
    async function fetchData() {
      if (!isLoaded) {
        await getSchoolTesters();
      }
    }
    fetchData();
  }, []);

  return (
    <Container>
      <NewTester
        isModalOpen={isProviderModalOpen}
        setIsModalOpen={setProviderModalOpen}
      />
      <TestersData
        isModalOpen={isProviderDetailsModalOpen}
        closeModal={() => setProviderDetailsModalOpen(false)}
        providerData={providerData}
      />
      <Title>
        טסטרים
        <CreateButton
          onClick={() => setProviderModalOpen(true)}
          text="צור חדש"
        />
      </Title>
      <Table
        data={testers}
        componentColumns={vehicleColumns}
        onRowClick={onRowClick}
      />
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    testers: state.TestersReducer.testers,
    isLoaded: state.TestersReducer.isLoaded,
    createVehicle: state.session.user.createVehicle,
    editVehicle: state.session.user.editVehicle,
  };
}

export default connect(mapStateToProps, {
  getSchoolTesters,
})(FundingBodies);
